module.exports = __webpack_public_path__ + "img/how-work-1.7f3b5fb2.png";